import React, { useEffect, useRef, useState } from 'react';
import './TestimonialComponent.scss';
import { FaQuoteLeft } from 'react-icons/fa';

// Put these images next to this file (rename as needed)
import t1 from './pahan.jpg';
import t2 from './nishami.jpg';
import t3 from './yasiru.jpg';
import t4 from './shanu.jpg';

const TESTIMONIALS = [
  {
    img: t1,
    names: 'Kulani & Pahan',
    quote:
      'Plan My Guest took away the chaos. RSVPs, seating, guest updates—everything was smooth, and we actually enjoyed planning.',
    meta: 'The Blue Water, Kaluthara • 05th June, 2025',
  },
  {
    img: t2,
    names: 'Nishami & Ashubodha',
    quote:
      'Our site looked beautiful and guests loved how easy it was to RSVP. The analytics helped us stay on top of things.',
    meta: 'The Golden Crown, Kandy • 5th August, 2025',
  },
  {
    img: t3,
    names: 'Dinithi & Yasiru',
    quote:
      'The seating planner saved so much time. We avoided last-minute stress and it all felt so elegant.',
    meta: 'Thurya Hotel, Waskaduwa • 12th June, 2024',
  },
  {
    img: t4,
    names: 'Shanuri & Ansala',
    quote:
      'From “Yes” to “I do”, everything felt organized. Support was responsive and kind—highly recommend!',
    meta: 'Avendra Gardens, Negombo • 5th November, 2025',
  },
];

const TestimonialComponent = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Reveal-on-scroll once
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="testimonials"
      className={`testimonials ${visible ? 'is-visible' : ''}`}
      aria-label="Couple testimonials"
    >
      <header className="t__head">
        <p className="t__eyebrow">Kind words from couples</p>
        <h2 className="t__title">Testimonials</h2>
        <p className="t__lead">Real experiences that made planning simpler and happier.</p>
      </header>

      <ul className="t__grid" role="list">
        {TESTIMONIALS.map((t, i) => (
          <li className="tcard" key={i}>
            {/* Photo */}
            <figure className="tcard__media">
              <img src={t.img} alt={`${t.names}`} loading="lazy" />
              {/* Decorative frame */}
              <span className="tcard__frame" aria-hidden="true" />
            </figure>

            {/* Quote bubble */}
            <blockquote className="tcard__quote">
              <FaQuoteLeft className="tcard__quoteicon" aria-hidden="true" />
              <p className="tcard__text">“{t.quote}”</p>
              <footer className="tcard__meta">
                <strong className="tcard__names">{t.names}</strong>
                <span className="tcard__dot">•</span>
                <span className="tcard__place">{t.meta}</span>
              </footer>
            </blockquote>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default TestimonialComponent;
